import React, { useState, useEffect, useContext } from "react";
import CustomBreadcrumb from "../../common/CustomBreadcrumb";
import { BreadCrum } from "../../common";
import { useNavigate, useLocation } from "react-router-dom";
import Dragger from "../Dragger/Dragger";
import { useDispatch, useSelector } from "react-redux";
import {
  createOrUpdateReleaseDocAction,
  createOrUpdateReleaseDocHandler,
} from "../../redux/action/createOrUpdateReleaseDoc";
import Loader from "../Loder/loader";
import { useCommonMessage } from "../../common/CommonMessage";
import { handleKeyPressSpace } from "../../common/CommonFunctions";
import { ThemeContext } from "../../common/themeContext";
import { useAdminPermissions, VIEW_ONLY_EMPTY_MESSAGE } from "../../hooks/useAdminPermissions";

const ManageReleaseDocuments = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { brandId } = useContext(ThemeContext);
  const { hasReleaseDocumentViewOnly, isPending: permissionsPending } =
    useAdminPermissions();
  const isViewOnly = hasReleaseDocumentViewOnly;
  const documentData = location.state?.documentData || null;
  const [documentName, setDocumentName] = useState(
    documentData?.documentName || "",
  );
  const [error, setError] = useState("");
  const createOrUpdateReleaseDocSelector = useSelector(
    (state) => state?.createOrUpdateReleaseDoc,
  );
  const messageApi = useCommonMessage();
  const [htmlEditorValue, setHtmlEditorValue] = useState(
    documentData?.fileHtml || "",
  );

  useEffect(() => {
    if (documentData && documentData.documentName) {
      setDocumentName(documentData.documentName);
      setHtmlEditorValue(documentData.fileHtml || "");
    }
  }, [documentData]);

  const handleDraggerSave = (values, formikBag) => {
    if (!documentName.trim()) {
      setError("Document Name is required");
      return;
    }
    setError("");
    const payload = {
      fileUrl: documentData?.fileUrl || "",
      fileHtml: values?.html_editor || htmlEditorValue || "",
      fileName: documentName,
      brandId: brandId,
      status:
        documentData?.status === true
          ? "ACTIVE"
          : documentData?.status === false
            ? "INACTIVE"
            : "ACTIVE",
      ...(documentData?.id ? { id: documentData.id } : {}),
    };
    dispatch(createOrUpdateReleaseDocHandler(payload));
  };

  useEffect(() => {
    if (createOrUpdateReleaseDocSelector?.data?.statusCode === 200) {
      messageApi.open({
        type: "success",
        content: createOrUpdateReleaseDocSelector?.data?.message,
      });
      dispatch(createOrUpdateReleaseDocAction.createOrUpdateReleaseDocReset());
      navigate("/release-documents");
    }
    if (createOrUpdateReleaseDocSelector?.message) {
      messageApi.open({
        type: "error",
        content: createOrUpdateReleaseDocSelector?.message,
      });
      dispatch(createOrUpdateReleaseDocAction.createOrUpdateReleaseDocReset());
    }
  }, [createOrUpdateReleaseDocSelector]);

  const hasHtmlContent = Boolean(htmlEditorValue?.trim());

  return (
    <>
      {(createOrUpdateReleaseDocSelector?.isLoading || permissionsPending) && (
        <Loader loaderTransform="loaderTransform" />
      )}
      <div className="rightside">
        <div className="rightcontent">
          {isViewOnly && documentData?.id ? (
            <>
              <p>
                <strong>Form</strong>
              </p>
              <CustomBreadcrumb
                items={[
                  { text: BreadCrum.HOME },
                  {
                    text: "Release Document Management",
                    onClick: () => navigate("/release-documents"),
                  },
                  { text: documentName || documentData?.documentName, active: true },
                ]}
              />
              <div className="release-document-view-header mb-30">
                <p className="release-document-view-title">View Document</p>
                <hr className="my-20" />
                <p className="release-document-view-name">
                  {documentName || documentData?.documentName}
                </p>
              </div>
              <div className="table-padding mb-40 release-document-view-panel">
                <div className="release-document-view-tab">HTML</div>
                <hr className="m-0" />
                <div className="release-document-view-content">
                  {hasHtmlContent ? (
                    <div
                      className="release-document-view-html"
                      dangerouslySetInnerHTML={{ __html: htmlEditorValue }}
                    />
                  ) : (
                    <p className="release-document-view-empty">
                      {VIEW_ONLY_EMPTY_MESSAGE}
                    </p>
                  )}
                </div>
              </div>
              {/* <div className="text-end">
                <button
                  type="button"
                  onClick={() => navigate("/release-documents")}
                  className="border-0 py3 fw-18 gbo ms-auto bgtransparent addcreatebtn"
                >
                  <span>Go back to listing</span>
                </button>
              </div> */}
            </>
          ) : (
            <>
              <CustomBreadcrumb
                items={[
                  { text: BreadCrum.HOME },
                  {
                    text: documentData?.id
                      ? BreadCrum.EDIT_RELEASE_DOCUMENT
                      : BreadCrum.RELEASE_DOCUMENTS,
                    onClick: () => {
                      navigate("/release-documents");
                      dispatch(
                        createOrUpdateReleaseDocAction.createOrUpdateReleaseDocReset(),
                      );
                    },
                  },
                  {
                    text: BreadCrum.MANAGE_RELEASE_DOCUMENTS,
                    active: true,
                  },
                ]}
              />
              <div className="table-padding mb-40">
                <div className="headtitle d-block">
                  <p className="heedprodct mb-3">
                    {documentData?.id ? "Edit Document" : "Add New Document"}
                  </p>
                  <hr />
                  <div className="login-form">
                    <div className="w-md-50 pe-md-2 mb-lg-0 mb-3 position-relative">
                      <label className="mb-2">Document Name*</label>
                      <input
                        type="text"
                        name="documentName"
                        placeholder="Document Name"
                        className="form-control"
                        maxLength={100}
                        value={documentName}
                        onKeyDown={handleKeyPressSpace}
                        onChange={(e) => {
                          setDocumentName(e.target.value);
                          if (error && e.target.value.trim()) setError("");
                        }}
                      />
                      {error && (
                        <div style={{ color: "red", fontSize: 14, marginTop: 4 }}>
                          {error}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <Dragger
                onlyHtmlEditer={true}
                hideSaveButton={false}
                documentName={documentName}
                documentId={documentData?.id}
                onBeforeSave={handleDraggerSave}
                initialHtml={htmlEditorValue}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ManageReleaseDocuments;
